import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { isWidgetExpandedState } from '@/state/session';
import { webChatStateState } from '@/state/socket';
export const ErrorPage = () => {
    const { t } = useTranslation();
    const isExpanded = useRecoilValue(isWidgetExpandedState);
    const setWebChatState = useSetRecoilState(webChatStateState);
    const handlePrimaryClick = () => {
        setWebChatState("create" /* WebChatState.Create */);
    };
    return (_jsx("div", { className: cn('absolute bottom-0 left-0 right-0 mx-3 mb-4 h-[222px] animate-[slide-in-up_0.2s_ease-out] rounded-lg border border-border shadow-lg will-change-transform'), children: _jsxs("div", { className: "flex h-full flex-col items-center justify-center gap-4 p-4", children: [_jsx(TriangleAlert, { size: 40, className: "text-destructive" }), _jsxs("div", { className: "text-surface-card-foreground mx-auto text-center text-lg font-semibold", children: [t('errors.reconnect'), _jsx("div", { className: "text-foreground-muted mx-auto mt-1 max-w-xs text-center text-sm font-normal leading-5", children: t('errors.restart_conversation') })] }), _jsx("div", { className: "flex w-full flex-col items-center justify-center gap-2", children: _jsx(Button, { className: cn(`w-full`, {
                            'w-sm': isExpanded,
                        }), onClick: handlePrimaryClick, children: t('buttons.restart') }) })] }) }));
};
